import { motion } from "framer-motion";
import { Users, BedDouble, Bath, Sun } from "lucide-react";
import { useI18n } from "../../i18n";

const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export default function Intro() {
  const { t } = useI18n();
  return (
    <section id="intro" className="relative py-28 md:py-40 lg:py-48 px-6 md:px-12 lg:px-20" data-testid="intro-section">
      <div className="grid grid-cols-12 gap-y-12 gap-x-8 lg:gap-x-16 max-w-7xl mx-auto">
        <Reveal className="col-span-12 md:col-span-5 lg:col-span-4">
          <span className="eyebrow" data-testid="intro-eyebrow">{t.intro.eyebrow}</span>
          <div className="mt-6 flex flex-col gap-5">
            {[
              { n: '5', label: t.intro.guests, Icon: Users },
              { n: '2', label: t.intro.bedrooms, Icon: BedDouble },
              { n: '2', label: t.intro.bathrooms, Icon: Bath },
              { n: '1', label: t.intro.terrace, Icon: Sun },
            ].map((s, i) => (
              <div key={i} className="flex items-center gap-5 border-b border-charcoal/10 pb-3" data-testid={`intro-spec-${i}`}>
                <span className="font-serif text-4xl md:text-5xl text-charcoal leading-none">{s.n}</span>
                <s.Icon size={18} strokeWidth={1.1} className="text-charcoal/60" />
                <span className="text-xs tracking-luxe uppercase text-charcoal-mute">{s.label}</span>
              </div>
            ))}
          </div>
        </Reveal>

        <div className="col-span-12 md:col-span-7 lg:col-span-8 lg:pl-12">
          <Reveal delay={0.1}>
            <h2 className="font-serif-display text-5xl md:text-6xl lg:text-[5.5rem] whitespace-pre-line text-charcoal" data-testid="intro-title">
              {t.intro.title}
            </h2>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-10 md:mt-12 text-base md:text-lg leading-relaxed text-charcoal-soft max-w-xl">
              {t.intro.body}
            </p>
          </Reveal>
          <Reveal delay={0.35}>
            <p className="mt-6 text-xs md:text-sm tracking-[0.18em] uppercase text-charcoal-mute" data-testid="intro-details">
              {t.intro.details}
            </p>
          </Reveal>
          <Reveal delay={0.5}>
            <div className="mt-12 flex items-center gap-4 text-xs tracking-luxe uppercase text-charcoal">
              <span className="block w-10 h-px bg-charcoal/40" />
              <span>Sardegna · Mediterraneo</span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
